<template>
  <div id="page-wrap">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <section class="login-content col-md-8 col-xs-12">
          <header class="visible-xs text-center visible-sm ">
            <img height="50" src="/static/images/logo.svg" alt="Epaylater Logo">
            <div class="titleContent">
              <h2>Login</h2>
              <p>Access merchant account</p>
            </div>
          </header>
          <section class="loginForm clearfix">

            <form class="col-md-12"  @submit.prevent="login()">
              <div class="form-group">
                <label class="hidden-xs" for="text">Email Address</label>
                  <input type="email" id="email" v-model="query.email">
              </div>
              <div class="form-group">
                <label class="hidden-xs" for="text">Password</label>
                  <input type="password" id="password" v-model="query.password">
              </div>
              <div v-if="error" class="form-group">
                <label for="text" class="danger">{{error.message}}</label>
              </div>
              <div class="form-group text-center">
                <button class="btn btn-primary" type="submit">Login</button>
              </div>
            </form>
          </section>
        </section>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      error:undefined,
      query:{
        email:undefined,
        password:undefined,
        name:'epaylater-test'
      }
    }
  },
  methods:{
    login() {
      this.$store.dispatch("login", this.query).then(()=>{
        this.$router.push({ name:"Transactions" })
      }).catch((err)=>{
        this.error = err;
      })
    }
  },
  mounted(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../assets/scss/custom.scss';
  .login-content {
    position: relative;
    top:50vh;
    @include transform(translateY(-50%));
    background-size: contain;
    background-size: 71px 80px;
    background-position: 51% top;
    font-family: Overpass;
    background: white;
    height: 540px;
    header{
      margin: 70px 0 40px;
      .titleContent{
        margin: 30px 0;
        h2{
          font-size: 20px;
        }
        p{
          font-size: 12px;
        }
      }
    }
    .loginForm{
      max-width: 250px;
      position: relative;
      margin: 0 auto;
      form{
        padding: 0px;
        .form-group{
          margin-bottom: 20px;
          display: inline-block;
          width: 100%;
          .mobileWrapr{
            display: inline-block;
          }
          label{
            display: block;
            font-size: 12px;
            text-align: center;
            color: #b0bfd9;
            margin-bottom: 10px;
          }
          label.danger{
            color: #f45c5f;

          }
          input{
            float: left;
            text-align: center;
            background: white;
            border: 0;
            border-bottom: 1px solid rgba(75,85,102,.16);
            border-radius: 0;
            font-size: 20px;
            width: 100%;
            letter-spacing: -0.5px;
            box-shadow: 0 0 0;
            padding-top: 0px;
            &:hover, &:active, &:focus{
              outline:0;
              box-shadow: none;

            }
          }

          input[disabled="disabled"]{
            color: rgba(255,255,255,.35);
            padding-right: 2px;
            width:60px;
            text-align: right;
          }
          button{
            font-size: 16px;
            height: 50px;
            width: 120px;
            border: 0;
            border-radius: 23px;
            font-weight: bold;
          }
          &:nth-child(3){
            padding-top: 10px;
            text-align: center;
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue